import { appConfig } from 'utils/config';

const { createSlice } = require('@reduxjs/toolkit');

const initialState = {
  loading: false,
  notifications: [],
  filteredNotifications: [],
};

const { actions, reducer } = createSlice({
  name: 'notification',
  initialState,
  reducers: {
    setLoading: (state, action) => ({
      ...state,
      loading: action.payload,
    }),

    setNotification: (state, action) => {
      const { notifications, filteredNotifications } = action.payload;

      return { ...state, notifications, filteredNotifications };
    },
  },
});

export default reducer;

export const { setLoading, setNotification } = actions;

// ----------------------------------------------------------------------

export const getNotifications = (firestore, userId) => {
  const { environment } = appConfig;

  const env = environment === 'production' ? 'production' : 'staging';

  return async (dispatch) => {
    dispatch(setLoading(true));

    try {
      const snapshot = await firestore
        .collection('notification')
        .doc(env)
        .collection(userId.toString())
        .orderBy('createdAt', 'desc')
        .get();

      const parsedResponse = snapshot.docs.map((notif) => {
        return {
          id: notif.id,
          ...notif.data(),
        };
      });

      const filteredNotif = parsedResponse.filter((data) => {
        return data.isRead === false;
      });

      dispatch(
        setNotification({
          notifications: parsedResponse,
          filteredNotifications: filteredNotif,
        }),
      );
    } catch (err) {
      console.log(err);
    } finally {
      dispatch(setLoading(false));
    }
  };
};

// ----------------------------------------------------------------------
